module.exports = __webpack_public_path__ + "static/media/Kyurem_gaussian2.a4c17bdf.png";